///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createAction } from '@ngrx/store';

export const LOGOUT = '[App] Logout';
export const logoutAction = createAction('[App] Logout');
